import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/auth.js";

const routes: RouteRecordRaw[] = [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/LoginView.vue"),
        meta: { requiresAuth: false },
    },
    {
        path: "/",
        name: "dashboard",
        component: () => import("@/views/DashboardView.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/polls/create",
        name: "poll-create",
        component: () => import("@/views/PollCreateView.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/polls/:id",
        name: "poll-detail",
        component: () => import("@/views/PollDetailView.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/polls/:id/edit",
        name: "poll-edit",
        component: () => import("@/views/PollEditView.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/",
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore();

    // Wait for auth to initialize
    if (authStore.loading) {
        await authStore.initialize();
    }

    const requiresAuth = to.meta.requiresAuth !== false;

    if (requiresAuth && !authStore.isAuthenticated) {
        next({ name: "login", query: { redirect: to.fullPath } });
    } else if (to.name === "login" && authStore.isAuthenticated) {
        next({ name: "dashboard" });
    } else {
        next();
    }
});

export default router;
